module.exports = require('./lib/client');



// WEBPACK FOOTER //
// ./node_modules/@feathersjs/transport-commons/client.js